<template>
  <div class="directions-search">
    <v-text-field
      v-model="searchInput"
      :label="label"
      :prepend-icon="(stop.name === '') ? '' : '$clear'"
      @click:prepend="clearStop()"
      append-icon="fa-location-arrow"
      @click:append="setToCurrentLocation()"
      append-outer-icon="fa-search"
      @click:append-outer="runSearch"
      v-on:keyup.enter="runSearch"
      :error="error" />

    <v-list v-if="resultsOnCampus.length || resultsOffCampus.length" dense>
      <v-list-item-group
        v-model="activeLocationIndex"
        color="primary">
        <template v-if="resultsOnCampus.length">
          <v-subheader>On Campus</v-subheader>
          <v-list-item
            v-for="(location, index) in resultsOnCampus"
            :key="`onCampus-${index}`"
            @mouseover="focusCoordinates([location.lat, location.lng])"
            @click="setStop(location)">
            <v-list-item-content>
              <v-list-item-title>{{ location.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="resultsOffCampus.length">
          <v-subheader>Off Campus</v-subheader>
          <v-list-item
            v-for="(location, index) in resultsOffCampus"
            :key="`offCampus-${index}`"
            @mouseover="focusCoordinates([location.center.lat, location.center.lng])"
            @click="setStop(location, false)">
            <v-list-item-content>
              <v-list-item-title>{{ location.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import search from '@/mixins/search'
import geocode from '@/mixins/geocode'

export default {
  name: 'DirectionsSearch',
  mixins: [search, geocode],
  props: {
    label: {
      type: String,
      default: 'Search...'
    },
    stop: {
      /*
        id: String,
        name: String,
        lat: Number,
        lng: Number
      */
      type: Object
    }
  },
  data () {
    return {
      searchInput: '',
      error: false,
      resultsOnCampus: [],
      resultsOffCampus: [],
      activeLocationIndex: -1
    }
  },
  created () {
    if (this.stop.name) {
      this.searchInput = this.stop.name
    }
  },
  watch: {
    stop () {
      this.searchInput = this.stop.name
    }
  },
  computed: {
    ...mapGetters([
      'currentLocation'
    ])
  },
  methods: {
    async runSearch () {
      this.resultsOnCampus = await this.search(this.searchInput)
      this.resultsOffCampus = await this.geocode(this.searchInput)
    },
    focusCoordinates (coordinates) {
      this.$root.$emit('focus-coordinates', coordinates)
    },
    setStop (location, onCampus = true) {
      const stop = {
        name: location.name
      }

      if (onCampus) {
        stop.id = location._id
        stop.lat = location.lat
        stop.lng = location.lng
      } else {
        stop.lat = location.center.lat
        stop.lng = location.center.lng
      }

      this.$emit('update:stop', stop)

      this.resultsOnCampus = []
      this.resultsOffCampus = []
    },
    setToCurrentLocation () {
      if (!this.currentLocation.lat || !this.currentLocation.lng) {
        this.$root.$emit('locate-user')
      } else {
        this.setStop({
          name: 'Current Location',
          lat: this.currentLocation.lat,
          lng: this.currentLocation.lng
        })
      }

      this.$root.$on('user-located', (data) => {
        this.setStop({
          name: 'Current Location',
          lat: this.currentLocation.lat,
          lng: this.currentLocation.lng
        })

        this.$root.$off('user-located')
      })
    },
    clearStop () {
      this.setStop({
        name: '',
        lat: 0,
        lng: 0
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css';
@import '../../../node_modules/leaflet-control-geocoder/Control.Geocoder.css';
</style>
